module.exports = __webpack_public_path__ + "static/media/ionicons.2c2ae068.eot";